const selectLanguages = state => state.data.languages

const LanguageDataStoreSelectors = {
  languages: selectLanguages
}

export default LanguageDataStoreSelectors
